import { NAMESPACE } from './constants'

export const openModal = NAMESPACE + '/OPEN_MODAL'
export const closeModal = NAMESPACE + '/CLOSE_MODAL'